import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=6a489481&scoped=true"
import script from "./selectProject.vue?vue&type=script&lang=js"
export * from "./selectProject.vue?vue&type=script&lang=js"
import style0 from "./selectProject.vue?vue&type=style&index=0&id=6a489481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a489481",
  null
  
)

export default component.exports